import { call, select } from 'redux-saga/effects';

import { selectActiveVenueId } from 'selectors/general';
import { makePath } from 'helpers/link-generation';

export function* redirectHome(client) {
  const activeVenueId = yield select(selectActiveVenueId);
  yield call(client.navigate, makePath.home(activeVenueId));
}
